<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">Scheme</strong>
        </div>
        <div class="col-md-5"> 
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-warning" :to="'/mutual-funds/qualitative-statements'">
              <i :title="'Qualitative Statements'" class="fa fa-edit cwhite"></i> Qualitative Statement
            </router-link>
            <router-link class="btn btn-sm btn-small btn-primary" :to="'/mutual-funds/edit-debt/ratings'">
              <i :title="'Edit Rating'" class="fa fa-edit cwhite"></i> Debt Ratings
            </router-link>
            <router-link class="btn btn-sm btn-small btn-primary" :to="'/mutual-funds/edit-mf-form/multiplier'">
              <i :title="'Edit Debt Multiplier'" class="fa fa-edit cwhite"></i> Debt Multiplier
            </router-link>
            <router-link class="btn btn-sm btn-small btn-primary" :to="'/mutual-funds/edit-mf-rating-form/ratings_number_and_text'">
              <i :title="'Edit Ratings'" class="fa fa-edit cwhite"></i> Star Ratings
            </router-link>
          </div>        
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-6">
          </div>
        </div>
           <div class="mb10"></div>
            <div class="row mb5">
              <div class="col-md-11">
                <div class="row">
                  <div class="col-md-3" v-if="checkInArray(dateFilterTabs, rawDataType)">
                    <div class="form-group">
                      <datepicker
                        :input-class="'form-control'"
                        :format="'dd-MM-yyyy'"
                        v-model="durDate"
                        @selected="getDateData($event)"
                        :disabledDates="disabledDates"
                        :placeholder="'Select Date'"
                      ></datepicker>
                    </div>
                  </div>
                 
                  <div class="col-md-5" v-if="rawDataType=='schemes'">
                    <div class="form-group">
                      <v-select
                        :options="schemeList"
                        :placeholder="'Select Scheme'"
                        :label="'name'"
                        v-model="selScheme"
                        @input="getScheme"
                        >
                    </v-select>
                    </div>
                  </div>
                 
                  <div class="col-md-3" v-if="rawDataType=='schemes'">
                    <div class="form-group">
                      <input
                        type="text"
                        v-model="lname"
                        class="form-control"
                        name="lname"
                        placeholder="Search by LName"
                        @keyup.enter="filterSchemes"
                      >
                    </div>
                  </div>
                  <div class="col-md-4" v-if="rawDataType=='schemes'">
                    <div class="form-group">
                      <!-- <input
                        type="text"
                        v-model="fund_manager"
                        class="form-control"
                        name="fund_manager"
                        placeholder="Search by Fund Manager"
                      > -->
                      <v-select
                        :options="fundManagerList"
                        :placeholder="'Select Fund Manager'"
                        :label="'name'"
                        v-model="selFundManager"
                        @input="filterSchemes"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-md-3" v-if="rawDataType=='schemes'">
                    <div class="form-group">
                      <input
                        type="text"
                        v-model="category"
                        class="form-control"
                        name="category"
                        placeholder="Search by Category"
                        @keyup.enter="filterSchemes"
                      >
                    </div>
                  </div>
               
                  <div class="col-md-1" v-if="rawDataType=='schemes'">
                    <div class="form-group">
                      <button class="btn btn-primary" @click="getRawData">Filter</button>
                    </div>
                  </div>
                  <div class="col-md-1" v-if="rawDataType=='schemes'">
                    <div class="form-group">
                      <button class="btn btn-default" @click="resetFilter">Reset</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-1">
                <download :tableId="'mf'+rawDataType" :fileName="rawDataType"></download>
              </div>
            </div>
            <div class="row mb5">
              <div class="col-md-6">
                <div><router-link class="btn btn-sm btn-secondary" :to="'/mutual-funds/schemes/'" >View Scheme-wise data</router-link></div>
              </div>
              <div class="col-md-6" >
                <div class="pull-right">
                  <ul v-if="totalPages != 1" class="pagination">
                    <li :class="{disabled:prevDisabled}" class="page-item">
                      <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
                    </li>
                    <li :class="{disabled:prevDisabled}" class="page-item">
                      <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
                    </li>
                    <li
                      v-for="page in pages"
                      v-bind:key="page"
                      class="page-item"
                      :class="(current_page == page)? 'active':''"
                    >
                      <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
                    </li>
                    <li :class="{disabled:nextDisabled}" class="page-item">
                      <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
                    </li>
                    <li :class="{disabled:nextDisabled}" class="page-item">
                      <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
                    </li>
                  </ul>
                </div>
              </div>        
            </div>
        
            <div class="table-responsive scrollbar app" v-dragscroll="true" v-if="tableFields.length">
              <table :id="'mf'+rawDataType" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th v-if="actions.length">Actions</th>
                    <th
                      class="data-cell"
                      v-for="(field, index, key) in tableFields"
                      v-bind:key="'field'+field.rowind+index+key"
                    >          
                    <span >{{field.name}}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(tr, ind) in rawData" v-bind:key="'trBod'+'-'+ind">
                    <td>
                      <span v-if="rawDataType=='schemes'">
                        <span v-if="page>1">{{(perPage * (page-1)) + (ind+1)}}</span>
                        <span v-else>{{ind+1}}</span>
                      </span>
                      <span v-else>{{ind+1}}</span>
                    </td>

                    <td v-if="actions.length">
                    <div class="action-btn-wrapper" v-for="action in actions"
                        v-bind:key="'action'+action.tooltip">
                        <span v-if="action.isLink">
                      <router-link
                        style="margin:1px 4px"
                        class="a-btn"
                        :class="action.btnClass"                        
                        :to="action.url+tr[action.param]"
                        :target="action.isNewWindow? '_blank': ''"
                        :title="action.tooltip" 
                      > {{action.tooltip}}
                      </router-link>
                        </span>
                        <span v-else><a
                        style="margin:1px 4px"
                        class="a-btn"
                        :class="action.btnClass"                        
                        @click.prevent="action.callback(tr['mf_schcode'])"
                        :title="action.tooltip" 
                      > {{action.tooltip}}
                      </a></span>
                    </div>
                  </td>

                    <td
                      v-for="(cl, index) in tableFields"
                      v-bind:key="index+'cldata'+cl.title"
                    >
                    <span v-if="cl.isLink">
                      <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                      <router-link class="a-btn" :to="'/mutual-funds/schemes/' + tr[cl.title]" target="_blank">{{tr[cl.title]}}</router-link>
                    </span>
                    <span v-else>
                      <span v-if="cl.datatype=='date'">{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                      <span v-else-if="cl.datatype=='numeric'">{{(tr[cl.title])? getChecknFixed(tr[cl.title]): '-'}}</span>
                      <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                    </span>
                    </td>
                    
                  </tr>
                </tbody>
              </table>
            </div>
           
            <div class="row">
              <div class="col-md-7"></div>
              <div class="col-md-5">
              <div class="pull-right">
                <ul v-if="totalPages != 1" class="pagination">
                  <li :class="{disabled:prevDisabled}" class="page-item">
                    <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
                  </li>
                  <li :class="{disabled:prevDisabled}" class="page-item">
                    <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
                  </li>
                  <li
                    v-for="page in pages"
                    v-bind:key="page"
                    class="page-item"
                    :class="(current_page == page)? 'active':''"
                  >
                    <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
                  </li>
                  <li :class="{disabled:nextDisabled}" class="page-item">
                    <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
                  </li>
                  <li :class="{disabled:nextDisabled}" class="page-item">
                    <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="row mb5" v-if="!tableFields.length">
            <div class="col-md-12"><div class="alert alert-danger" role="alert">No data found!</div></div>
          </div>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
import Datepicker from "vuejs-datepicker";

import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { rawMixins } from "../../assets/mixins/rawMixins.js";

export default {
  components: { Datepicker},
  mixins: [commonMixins, rawMixins],
  created() {
    this.rawDataType = this.rawDataList[this.selRowInd].id;
    localStorage.setItem("mutualTab", this.rawDataType);
    localStorage.setItem("selMutualTab", this.selMutualTab);
    this.getRawData();
    this.loadInitialData();
    console.log("Rawtype", this.rawDataType, this.selMutualTab);
  },
  methods: {
    getRawData() {
      if(!this.isApiCalled) {
        this.isApiCalled = 1;
        this.rawData = [];
        this.tableFields = this.catwiseTableFields = this.fundmngTableFields = [];
        this.actions = [];
        this.totalPages = 1;
        let myself = this;
        let apiUrl = this.rawDataApi+this.rawDataType;
        console.log(this.rawDataType);
        if(this.rawDataList[this.selRowInd].isPaginate) {
          apiUrl = apiUrl + '?page=' +this.page;
          if(this.durDate!=null) {
            apiUrl = apiUrl + '&date=' + this.getYMDDate(this.durDate);
          }
        } else {
          if(this.durDate!=null) {
            apiUrl = apiUrl + '?date=' + this.getYMDDate(this.durDate);
          }
        }
        if(this.rawDataType === "schemes") {
          // apiUrl = apiUrl + '?page=' +this.page;
          if(this.selFundManager != null && this.selFundManager.fund_manager){
            console.log(this.selFundManager);
            apiUrl = apiUrl + '&fund_manager=' + this.selFundManager.fund_manager;
          }
          if(this.scheme_name != ''){
            apiUrl = apiUrl + '&scheme_name=' + encodeURIComponent(this.scheme_name);
          }
          if(this.category != ''){
            apiUrl = apiUrl + '&category=' + this.category;
          }
          if(this.lname != ''){
            apiUrl = apiUrl + '&lname=' + this.lname;
          }
        } 
        console.log('APIURL', apiUrl);
        http.get(
          apiUrl,
          {},
          (error, response) => {
            console.log("Response",this.rawDataType, response.data);
            if(response.status == 'success' || response.message == 'success') {
              if(this.rawDataType === "schemes") {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: tf,
                        isLink: (tf=='mf_schcode')? 1: 0,
                        datatype: (tf=='LaunchDate' || tf=='navdate')? 'date': '',
                        sort_order: (tf=='MF_COCODE')? 1: (tf=='mf_schcode')? 2: (tf=='Category')? 3
                        : (tf=='MCAPCategory')? 4
                        : (tf=='mf_schname' || tf=='mf_schname' || tf=='SCH_NAME' || tf == 'sch_name')? 5 
                        : (tf=='LNAME')? 5
                        : (tf=='LaunchDate')? 6
                        : (tf=='FundManager')? 7
                        : (tf=='SchemeAUM')? 8
                        : (tf=='navrs')? 9
                        : (tf=='frequency')? 10
                        : (tf=='navdate')? 11
                        : (tf=='InvestmentType')? 12
                        : (tf=='FundType')? 13
                        : (tf=='ClassCode')? 14
                        : (tf=='EntrytLoad')? 15
                        : (tf=='MinInvestment')? 16
                        : (tf=='MinInvestment_SIP')? 17
                        : (tf=='IncrementalInvestment')? 18
                        : (tf=='ExitLoad')? 19
                        : (tf=='isin')? 20
                        : (tf=='isin_Reinvestment')? 21
                        : (tf=='rtcode')? 22
                        : (tf=='amficode')? 23
                        : 99,                    
                      });
                    }
                    this.actions = [{
                        btnClass: "btn-primary",
                        icon: "",
                        callback: this.showSchemeHoldings,
                        tooltip: "Holdings",
                        isLink: 1,
                        url: '/mutual-funds/schemeholdings/',
                        param: 'mf_schcode',
                        isNewWindow: 1,
                      }, {
                        btnClass: "btn-warning",
                        icon: "",
                        callback: this.showSchemeRatios,
                        tooltip: "Ratios",
                        isLink: 1,
                        url: '/mutual-funds/schemeratios/',
                        param: 'mf_schcode',
                        isNewWindow: 1,
                      }, {
                        btnClass: "btn-success",
                        icon: "",
                        callback: this.showSchemeRatios,
                        tooltip: "Profile Exp Ratios",
                        isLink: 1,
                        url: '/mutual-funds/schemeprofileexpratios/',
                        param: 'mf_schcode',
                        isNewWindow: 1,
                      }, {
                        btnClass: "btn-primary",
                        icon: "",
                        callback: this.showSchemeRatios,
                        tooltip: "Analysis",
                        isLink: 1,
                        url: '/mutual-funds/analysis/',
                        param: 'mf_schcode',
                        isNewWindow: 1,
                      }, {
                        btnClass: "btn-info",
                        icon: "",
                        callback: this.showSchemeRatios,
                        tooltip: "Analysis Sum",
                        isLink: 1,
                        url: '/mutual-funds/analysis-sum/',
                        param: 'mf_schcode',
                        isNewWindow: 1,
                      }, {
                        btnClass: "btn-secondary",
                        icon: "",
                        callback: this.showSchemeRatios,
                        tooltip: "Holding Mix",
                        isLink: 1,
                        url: '/mutual-funds/schemes/',
                        param: 'mf_schcode',
                        isNewWindow: 1,
                      }]
                  });
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                }
              
              } else {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='navdate')? 'date': '',
                        sort_order: (tf=='mf_schcode')? 1
                        : (tf=='mf_schname' || tf=='SCH_NAME')? 2 
                        : (tf=='navdate')? 3
                        : (tf=='Tax_Type')? 4
                        : (tf=='ISIN')? 5
                        : (tf=='NAV')? 6
                        : (tf=='SellNav')? 7 
                        : (tf=='RePurchaseNAV')? 8 
                        : 10
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields);
                }              
              }
            // console.log("this.rawData", this.rawData);
            this.rawDataList[this.selRowInd].items = this.rawData;
            if(response.total_pages) {
              myself.perPage = myself.rawData.length;
                myself.totalPages = response.total_pages ? response.total_pages : 1;
                let i = 8;
                let page = myself.current_page - 2;
                if (page <= 0) page = 1;
                myself.pages = [];
                while (i) {
                  myself.pages.push(parseInt(page));
                  if (myself.totalPages <= page) break;
                  page++;
                  i--;
                }
            }
            this.isApiCalled = 0;
          }
          });
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.prevDisabled = 0;
      this.fillTable();
    },
    fillTable() {
      this.page = this.pageToLoad;
      if (this.pageToLoad == this.totalPages) {
        this.nextDisabled = 1;
      } else {
        this.nextDisabled = 0;
      }
      if (this.pageToLoad == 1) {
        this.prevDisabled = 1;
      } else {
        this.prevDisabled = 0;
      }
      this.current_page = this.pageToLoad;
      this.getRawData();
    },
    clearPagination() {
      this.page = 1;
      this.current_page = 1;
      this.pageToLoad = 1;
      this.totalPages = 1;
      this.prevDisabled = 1;
      this.nextDisabled = 0;
      this.pages = [];
    },
    showSchemeHoldings(mfcode) {
      this.$router.push({ path: `/schemeholdings/${mfcode}` });
    },
    showSchemeRatios(mfcode) {
      this.$router.push({ path: `/schemeratios/${mfcode}` });
    },
    search() {
      if (this.searchText === null || this.searchText === "") {
          this.rawData = this.searchData;
          return this.rawData;
      } else if (this.searchText.length <= 2) {
          this.rawData = this.searchData;
          return this.rawData;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawData = this.searchData.filter(rd => {
          return (
              rd.nameamc.toLowerCase().includes(this.searchText.toLowerCase()) ||
              (rd.LNAME ?
                  rd.LNAME.toLowerCase().includes(this.searchText.toLowerCase()) :
                  false)
          );
        });
      }
    },
    filterSchemes() {
      if(this.amc_name.length > 1 || this.scheme_name.length > 1 || this.lname.length > 1 || this.selFundManager != null || this.category.length > 1 || this.invType.length > 1){
        this.getRawData();
      } else {
        this.getRawData();
      }
    },
    resetFilter() {
      this.fund_manager = this.scheme_name = this.lname = this.category = this.scheme_class = '';
      this.amc_name = '';
      this.selScheme = null;
      this.durDate = null; // new Date('2020-03-31'); //
      this.getRawData();
    },
    getScheme(){
      this.scheme_name = this.selScheme.name;
      // console.log(this.selScheme);
      this.filterSchemes();
    },
    getFundManagerList() {
      let _this = this;
      http.get("mutual-funds/fund-manager", {}, function(error, response) {
        if(response.status == 'success'){
          var fundManagerList = response.data;
          var uniqueFundManagers = [];
          if (fundManagerList.length > 0) {
            fundManagerList.forEach((fundManager) => {
              if(_this.checkNotInArray(uniqueFundManagers, fundManager.fund_mgr)) {
                uniqueFundManagers.push(fundManager.fund_mgr);
                _this.fundManagerList.push({name: fundManager.fund_mgr, fund_manager: fundManager.fund_mgr});
              }
            });
            _this.fundManagerList = _this.sorted_fields_asc(
              _this.fundManagerList,
              "name"
            );
          }
        }
      });
    },
    getSchemesList() {
      let _this = this;
      http.get("mutual-funds/schemes?onlyCodeAndNames=1", {}, function(error, response) {
        if(response.status == 'success') {
          var schemeList = response.data;
          if (schemeList.length > 0) {
            schemeList.forEach((scheme) => {
              _this.schemeList.push({id: scheme.mf_schcode, name: scheme.sch_name});
            });
            _this.schemeList = _this.sorted_fields_asc(
              _this.schemeList,
              "id"
            );
          }
        }
      });
    },
    loadInitialData() {
      if(this.rawDataType == 'schemes') {
        console.log('load schemes'); 
        this.getFundManagerList();
        this.getSchemesList();
      }    
    },
    sortColumn(field, ind) {
      this.sort = field.title;
      var sortOrder = field.sort == 0 ? 2 : field.sort == 1 ? 2 : 1;      
      console.log(ind, sortOrder, typeof sortOrder, this.tableFields[ind], this.tableFields);
      if (sortOrder == 2) {
        this.sortOrder = 'DESC';
      } else  {
        this.sortOrder = 'ASC';
      }      
      this.tableFields[ind]['sort'] = sortOrder;
      console.log(this.sort, this.sortOrder);
      this.getRawData();
    },
    getDateData(e) {
      console.log("Date Selected", e);
      this.durDate = e;
      this.filterSchemes();
    },
    getSchemeClassCode () {
      this.schemeClassCode = this.selSchemeClass.classcode;
      // console.log(this.selScheme);
      this.getRawData();
    },
  },
  data() {
    return {
      durDate: null, //  new Date('2020-03-31'), //null,
      // durDate: new Date().setDate(new Date().getDate() - 1),
      disabledDates: {
        from: new Date(new Date().setDate(new Date().getDate() - 1))
      },
      dateFilterTabs: ['whats-in-out',
       'analysis', 'analysis-sum',
        'scheme-holdings'],
      selMutualTab: "",
      tableFields: [],
      tableColumns: [],
      catwiseTableFields: [],
      fundmngTableFields: [],
      searchText: "",
      schemeList: "",
      selScheme: null,
      fund_manager: '',
      selFundManager: null,
      fundManagerList: [],
      schemeList: [],
      scheme_name: '',
      scheme_class: '',
      schemeClassCode: '',
      selSchemeClass: null,
      isDownload: 0,
      scheme_class_codes: [],
      lname: '',
      amc_name: '',
      category: '',
      invType: '',
      sortOrder: '',
      sort: '',
      actions: [],
      isApiCalled: 0,
      param: "schemes",
      currentComp: "",
      rawDataList: [
        { id: "schemes", value: "Schemes", open: false, items: {}, isPaginate: 1 },
      ],
      rawDataType: "schemes",
      rawDataApi: "mutual-funds/",
      rawData: [],
      fillableData: [],
      selRowInd: 0,
      page: 1,
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      perPage: 200,
    }
  },
  computed: {
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
.table tr th span.sort.active{
  color: #ced4da;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/scheme.vue